// extracted by mini-css-extract-plugin
module.exports = {"background":"style__background__C1jRJ","title":"style__title__chvRa"};